import { AccountFeatures, AppContext, Features } from '@lightspeed-invoicing/core-client/frontend'
import BottomPriceEdit from "./bottom-line/sections/BottomPriceEdit"
import CalendarEventEdit from "./calendar/components/CalendarEventComponent.jsx"
import CalendarEdit from './calendar/edit.component.jsx'
import CalendarListing from './calendar/listing.component.jsx'
import CalendarNew from './calendar/new.component.jsx'
import CalendarEventPage from "./calendar/pages/CalendarEventPage"
import CompanyList from './company/listing/CompanyListing'
import ConnectRedirect from './connect/connectredirect.component.jsx'
import CustomFieldDefinitionEdit from './custom-field/edit.component.jsx'
import CustomFieldDefinitionListing from './custom-field/listing.component.jsx'
import CustomFieldDefinitionNew from './custom-field/new.component.jsx'
import CustomerList from './customer/List'
import AccountStatementDetails from './customer/account-statement/AccountStatementDetails'
import CustomerDetails from './customer/details.component.jsx'
import CustomerNew from "./customer/newCustomer.component.jsx"
import SupplierDetails from './customer/supplier/components/SupplierDetails'
import SupplierPage from './customer/supplier/components/SupplierPage'
import SupplierListing from './customer/supplier/components/listing/SupplierListing'
import DashboardPage from './dashboard/DashboardPage'
import NewInvoiceModalEmbed from "./embed/ls-retail/newinvoicemodal.component.jsx"
import Orders from "./embed/ls-retail/orders.component.jsx"
import SendInvoiceEmailModalEmbed from "./embed/ls-retail/sendinvoiceemailmodal.component.jsx"
import CreateQuoteFromOrderEmbed from "./embed/zendesk-sell/createquotefromorder.component.jsx"
import ModelEdit from './guided-selling/edit.component.jsx'
import ModelListing from './guided-selling/listing.component.jsx'
import ModelNew from './guided-selling/new.component.jsx'
import MessageListing from "./inbox/list.component.jsx"
import IntegrationEdit from './integration/edit.component.jsx'
import NewDocumentComponent from './integration/hubspot/NewDocumentComponent'
import IntegrationListing from './integration/listing.component.jsx'
import IntegrationNew from './integration/new.component.jsx'
import {
    InventoryDocumentTypesPage,
    InventorySettingsPage,
    InventoryStockControlPage, InventoryStockDocumentEditPage,
    InventoryStockLocationsPage
} from "./inventory"
import CreateStockLocationPage from './inventory/pages/CreateStockLocationPage'
import EditStockLocationPage from './inventory/pages/EditStockLocationPage'
import { StockImportsPage } from "./inventory/pages/StockImportsPage"
import InvoiceListing from "./invoice/List"
import SubscriptionsListing from "./invoice/SubscriptionsList"
import InvoiceAgeingReport from "./invoice/ageingreport.component.jsx"
import CreditMemoListing from './invoice/credit-memo/CreditMemoListing'
import InvoiceEdit from "./invoice/invoice.component.jsx"
import LightspeedSalesListing from "./invoice/lightspeed/lightspeedsaleslisting.component.jsx"
import ReceiptsListing from "./invoice/receiptsListingComponent"
import ReturnListing from "./invoice/returnlisting"
import LabelEdit from './label/edit.component.jsx'
import LabelListing from './label/listing.component.jsx'
import LabelNew from './label/new.component.jsx'
import LocationEdit from "./location/edit.component.jsx"
import EditLocationTemplateForm from './location/form/EditLocationTemplateForm'
import LocationListing from "./location/listing.component.jsx"
import LocationNew from "./location/new.component.jsx"
import MyAccount from './my-account/myAccount.component.jsx'
import NylasMigrationComponent from './nylas/NylasMigrationComponent'
import Congratulations from './onboarding/congratulations.component.jsx'
import OnBoardingPage from './onboarding/pages/OnBoardingPage.jsx'
import VendRedirectSubscription from './onboarding/vend/VendRedirectSubscriptionComponent.tsx'
import OrderStatusEdit from "./order-status/edit.component.jsx"
import OrderStatusNew from "./order-status/new.component.jsx"
import ItemReportListing from './order/ItemReportListing'
import OrderListing from "./order/List"
import OrderEdit from "./order/order.component.jsx"
import PaymentProcessingPage from './payment-processing/PaymentProcessingPage'
import Configuration3DSSetup from './payment-processing/configuration-3ds/Configuration3DSSetup'
import MerchantOnboardingPage from './payment-processing/merchant-onboarding/MerchantOnboardingPage'
import RainforestMerchantOnboardingEdit from './payment-processing/merchant-onboarding/RainforestMerchantOnboardingEdit'
import PaymentProcessingAccounts from './payment-processing/payment-account-listing/PaymentProcessingAccounts'
import PaymentProcessingPayments from './payment-processing/payment-listing/PaymentProcessingPayments'
import PaymentProcessingPayouts from './payment-processing/payout-listing/PaymentProcessingPayouts'
import TerminalListing from './payment-processing/terminal-listing/TerminalListing'
import PaymentTermEdit from './payment-term/edit.component.jsx'
import PaymentTermListing from './payment-term/listing.component.jsx'
import PaymentTermNew from './payment-term/new.component.jsx'
import PaymentTypeEdit from './payment-type/edit.component.jsx'
import PaymentTypeListing from './payment-type/listing.component.jsx'
import PaymentTypeNew from './payment-type/new.component.jsx'
import PaymentDetails from './payment/components/PaymentDetails.tsx'
import PaymentListingPage from './payment/listing/paymentListingPage'
import PriceListListing from "./price-list/List"
import PriceListEdit from "./price-list/pricelist.component.jsx"
import Products from './product/Products'
import Structures from './product/Structures'
import BundleListing from './product/bundle/components/BundleListing.tsx'
import CreateBundleComponent from './product/bundle/components/CreateBundleComponent.tsx'
import EditBundleComponent from './product/bundle/components/EditBundleComponent.tsx'
import ImportEditPage from './product/import/ImportEditPage'
import ImportListing from './product/import/listing.component.jsx'
import AssemblyNew from './product/newassembly.component.jsx'
import MatrixNew from './product/newmatrix.component.jsx'
import ProductCreatePage from './product/pages/ProductCreatePage'
import ProductEditPage from './product/pages/ProductEditPage'
import PriceLevelListing from './product/price-level/PriceLevelListing.tsx'
import CreatePriceLevelComponent from './product/price-level/components/CreatePriceLevelComponent.tsx'
import EditPriceLevelComponent from './product/price-level/components/EditPriceLevelComponent.tsx'
import ProposalPreview from './proposal/preview.component.jsx'
import QuoteEdit from './quote/edit.component.jsx'
import QuoteListing from './quote/listing/List'
import RelationshipEdit from './relationship/edit.component.jsx'
import RelationshipListing from './relationship/listing.component.jsx'
import RelationshipNew from './relationship/new.component.jsx'
import QuoteMonthlyReportEmbed from "./report/quotemonthlyreport.component.jsx"
import { Permissions } from './role/Guard.jsx'
import RoleEdit from "./role/edit.component.jsx"
import RoleListing from "./role/listing.component.jsx"
import RoleNew from "./role/new.component.jsx"
import AppointmentListing from "./scheduling-page/AppointmentListing"
import SchedulingPageListing from "./scheduling-page/SchedulingPageListing"
import SchedulingPageEdit from "./scheduling-page/schedulingpage.component.jsx"
import AccountSettings from './settings/account.component.jsx'
import AccountDetailsEditForm from './settings/account/detailsEditForm.component.jsx'
import BrandingSettings from "./settings/branding.component.jsx"
import CompanyDetailsEdit from './settings/companyDetails/companyDetailsEdit.component.jsx'
import EcommerceConfigurationPage from './settings/ecommerce/pages/EcommerceConfigurationPage'
import EmailTemplatesEditForm from './settings/emails/editForm.component.jsx'
import EmailTemplateNew from './settings/emails/new.component.jsx'
import EmailTemplatesListing from './settings/emails/templateslisting.component.jsx'
import FeeSection from './settings/fees/FeeSection'
import FeeEdit from "./settings/fees/edit.component.jsx"
import FeeNew from "./settings/fees/new.component.jsx"
import ProposalTemplatesEditForm from './settings/proposals/editForm.component.jsx'
import ProposalOptionsEditForm from './settings/proposals/optionsEditForm.component.jsx'
import SMSTemplatesListing from './settings/sms/SMSTemplatesListing'
import SMSTemplatesEditForm from "./settings/sms/editSMSTemplateForm"
import SMSTemplateNew from './settings/sms/newSMSTemplate'
import TaxEdit from './settings/taxes/taxEdit.component.jsx'
import TaxNew from './settings/taxes/taxNew.component.jsx'
import TaxSection from './settings/taxes/taxSection.component.jsx'
import StatusPage from "./status/pages/StatusPage"
import TemplateEdit from "./template/edit.component.jsx"
import TemplateListing from "./template/listing.component.jsx"
import TemplateNew from "./template/new.component.jsx"
import TemplateSectionEdit from "./template/sections/edit.component.jsx"
import TemplateSectionNew from "./template/sections/new.component.jsx"
import TemplatePreview from "./template/sections/preview.component.jsx"
import PasswordSettings from './user/PasswordSettingsComponent'
import SignatureSettings from './user/SignatureSettingsComponent.tsx'
import UserEdit from './user/edit.component.jsx'
import UserListing from './user/listing.component.jsx'
import UserNew from './user/new.component.jsx'
import NotificationSettings from './user/notificationSettings/NotificationSettingsComponent.tsx'
// Each logical "route" has two components, one for
// the sidebar and one for the main area. We want to
// render both of them in different places when the
// path matches the current URL.

// should be separated by '|', e.g. "ls-retail|quick-books|kangaroo"
const supportedSignUpIntegrations = "ls-retail|shopify|shopify-expert-app|vend|square"

const AppRoutes = [
    {
        path: '/',
        exact: true,
        main: DashboardPage,
    },
    {
        path: `/embed/connect/:integrationKey(${supportedSignUpIntegrations})`,
        exact: true,
        main: ConnectRedirect,
    },

    {
        path: '/congrats',
        exact: true,
        main: Congratulations,
    },

    {
        path: '/embed/reports/quote-monthly-report/:year/:month',
        exact: true,
        main: QuoteMonthlyReportEmbed,
    },
    {
        path: '/quotes/new',
        exact: true,
        main: QuoteEdit,
    },
    {
        path: '/quotes/create-from/:fromProjectId/:fromQuoteId',
        exact: true,
        main: QuoteEdit,
    },
    {
        path: '/quotes/:quoteId/edit',
        exact: true,
        main: QuoteEdit,
    },
    {
        path: '/quotes/listing',
        exact: true,
        main: QuoteListing,
    },
    {
        path: '/orders/listing',
        exact: true,
        main: OrderListing,
        feature: AccountFeatures.FeatureOrder
    },
    {
        path: '/orders/item-report',
        exact: true,
        main: ItemReportListing,
        feature: AccountFeatures.FeatureOrder
    },
    {
        path: '/orders/:orderId/edit',
        exact: true,
        main: OrderEdit,
        feature: AccountFeatures.FeatureOrder
    },
    {
        path: '/price-lists/:priceListId/edit',
        exact: true,
        main: PriceListEdit,
        feature: AccountFeatures.FeaturePriceList
    },
    {
        path: '/price-lists/listing',
        exact: true,
        main: PriceListListing,
        feature: AccountFeatures.FeaturePriceList
    },
    {
        path: '/scheduling-pages/:schedulingPageId/edit',
        exact: true,
        main: SchedulingPageEdit,
        feature: AccountFeatures.FeatureScheduling
    },
    {
        path: '/scheduling-pages/listing',
        exact: true,
        main: SchedulingPageListing,
        feature: AccountFeatures.FeatureScheduling
    },
    {
        path: '/calendar-events/listing',
        exact: true,
        main: AppointmentListing,
        feature: AccountFeatures.FeatureScheduling
    },
    {
        path: '/calendar-events/new',
        exact: true,
        main: CalendarEventPage,
        feature: AccountFeatures.FeatureScheduling
    },
    {
        path: '/calendar-events/:calendarEventId/edit',
        exact: true,
        main: CalendarEventEdit,
        feature: AccountFeatures.FeatureScheduling
    },
    {
        path: '/invoices/:invoiceId/edit',
        exact: true,
        main: InvoiceEdit,
        feature: Features.Invoice
    },
    {
        path: '/inventory/imports/:importId/edit',
        exact: true,
        main: ImportEditPage,
        feature: AccountFeatures.FeatureInventory
    },
    {
        path: '/invoices/listing',
        exact: true,
        main: InvoiceListing,
        feature: Features.Invoice
    },
    {
        path: '/payments/listing',
        exact: true,
        main: PaymentListingPage,
    },
    {
        path: '/payments/:paymentId/edit',
        exact: true,
        main: PaymentDetails,
    },
    {
        path: '/account-statements/:accountStatementId/edit',
        exact: true,
        main: AccountStatementDetails,
    },
    {
        path: '/invoices/ageing-report',
        exact: true,
        main: InvoiceAgeingReport,
        feature: Features.Invoice
    },
    {
        path: '/recurring-invoices/listing',
        exact: true,
        main: SubscriptionsListing,
        feature: AccountFeatures.FeatureSubscriptions
    },
    {
        path: '/returns/:invoiceId/edit',
        exact: true,
        main: InvoiceEdit,
        feature: Features.Invoice
    },
    {
        path: '/returns/listing',
        exact: true,
        main: ReturnListing,
        feature: Features.Invoice
    },
    {
        path: '/credit-memos/listing',
        exact: true,
        main: CreditMemoListing,
        feature: Features.Invoice
    },
    {
        path: '/sales/listing',
        exact: true,
        main: LightspeedSalesListing,
        feature: Features.Invoice
    },
    {
        path: '/receipts/listing',
        exact: true,
        main: ReceiptsListing,
        feature: Features.Invoice
    },
    {
        path: '/proposals/:hash/preview',
        exact: true,
        main: ProposalPreview,
    },
    {
        path: '/contacts/listing',
        exact: true,
        main: CustomerList,
    },
    {
        path: '/companies/listing',
        exact: true,
        main: CompanyList,
    },
    {
        path: '/suppliers/listing',
        exact: true,
        main: SupplierListing,
    },
    {
        path: '/suppliers/new',
        exact: true,
        main: SupplierPage,
    },
    {
        path: '/suppliers/:supplierId/edit',
        main: SupplierPage,
        exact: true,
    },
    {
        path: '/suppliers/:supplierId/details',
        exact: true,
        main: SupplierDetails,
    },
    {
        path: '/contacts/new',
        main: CustomerNew,
        exact: true,
    },
    {
        path: '/contacts/:contactId/edit',
        main: CustomerNew,
        exact: true,
    },
    {
        path: '/contacts/:contactId/details',
        exact: true,
        main: CustomerDetails,
    },
    {
        path: '/products/catalog',
        main: Products,
        exact: true,
        requiredPermissions: [Permissions.AdminMenus],
    },
    {
        path: '/payment-processing',
        main: PaymentProcessingPage,
        exact: true,
        requiredPermissions: [Permissions.AccessQuoteMachinePayments],
    },
    {
        path: '/payment-processing/new-payment-account',
        main: MerchantOnboardingPage,
        exact: true,
        requiredPermissions: [Permissions.AccessQuoteMachinePayments],
    },
    {
        path: '/payment-processing/payments',
        main: PaymentProcessingPayments,
        exact: true,
        requiredPermissions: [Permissions.AccessQuoteMachinePayments],
    },
    {
        path: '/payment-processing/payouts',
        main: PaymentProcessingPayouts,
        exact: true,
        requiredPermissions: [Permissions.AccessQuoteMachinePayments],
    },
    {
        path: '/payment-processing/configuration-3ds',
        main: Configuration3DSSetup,
        exact: true,
        requiredPermissions: [Permissions.AccessQuoteMachinePayments],
    },
    {
        path: '/payment-processing/accounts',
        main: PaymentProcessingAccounts,
        exact: true,
        requiredPermissions: [Permissions.AccessQuoteMachinePayments],
    },
    {
        path: '/payment-accounts/:paymentAccountId/edit',
        main: RainforestMerchantOnboardingEdit,
        exact: true,
        requiredPermissions: [Permissions.AccessQuoteMachinePayments],
    },
    {
        path: '/stock-documents/:stockDocumentId/edit',
        main: InventoryStockDocumentEditPage,
        exact: true,
        feature: AccountFeatures.FeatureInventory,
    },
    {
        path: '/inventory/settings',
        main: InventorySettingsPage,
        exact: true,
        requiredPermissions: [Permissions.AccessInventory],
        feature: AccountFeatures.FeatureInventory,
    },
    {
        path: '/inventory/imports',
        main: StockImportsPage,
        exact: true,
        requiredPermissions: [Permissions.AccessInventory],
        feature: AccountFeatures.FeatureInventory,
    },
    {
        path: '/inventory/stock-locations',
        main: InventoryStockLocationsPage,
        exact: true,
        requiredPermissions: [Permissions.AccessInventory],
        feature: AccountFeatures.FeatureInventory,
    },
    {
        path: '/inventory/stock-control',
        main: InventoryStockControlPage,
        exact: true,
        requiredPermissions: [Permissions.AccessInventory],
        feature: AccountFeatures.FeatureInventory,
    },
    {
        path: '/inventory/document-types',
        main: InventoryDocumentTypesPage,
        requiredPermissions: [Permissions.AccessInventory],
        feature: AccountFeatures.FeatureInventory,
    },
    {
        path: '/payment-processing/terminals',
        main: TerminalListing,
        exact: true,
        requiredPermissions: [Permissions.AdminMenus],
    },
    {
        path: '/inventory/stock-locations/new',
        main: CreateStockLocationPage,
        exact: true,
        requiredPermissions: [Permissions.AdminMenus],
        feature: AccountFeatures.FeatureInventory,
    },
    {
        path: '/inventory/stock-locations/:stockLocationId/edit',
        main: EditStockLocationPage,
        exact: true,
        requiredPermissions: [Permissions.AdminMenus],
        feature: AccountFeatures.FeatureInventory,
    },
    {
        path: '/bundles',
        main: BundleListing,
        exact: true,
        requiredPermissions: [Permissions.AdminMenus],
    },
    {
        path: '/bundles/new',
        main: CreateBundleComponent,
        exact: true,
        requiredPermissions: [Permissions.AdminMenus],
    },
    {
        path: '/bundles/edit/:bundleId',
        main: EditBundleComponent,
        exact: true,
        requiredPermissions: [Permissions.AdminMenus],
    },
    {
        path: '/priceLevels/catalog',
        main: PriceLevelListing,
        exact: true,
        requiredPermissions: [Permissions.AdminMenus],
    },
    {
        path: '/priceLevels/new',
        main: CreatePriceLevelComponent,
        exact: true,
        requiredPermissions: [Permissions.AdminMenus],
    },
    {
        path: '/priceLevels/edit/:priceLevelId',
        main: EditPriceLevelComponent,
        exact: true
    },
    {
        path: '/imports/:type',
        main: ImportListing,
        exact: true,
    },
    {
        path: '/matrices/catalog',
        main: Structures,
        exact: true,
    },
    {
        path: '/products/edit/:productId',
        main: ProductEditPage,
        exact: true,
        requiredPermissions: [Permissions.UpdateProduct],
    },
    {
        path: '/products/edit/:parentId/variants/:productId',
        main: ProductEditPage,
        exact: true,
        requiredPermissions: [Permissions.UpdateProduct],
    },
    {
        path: '/matrices/new',
        main: MatrixNew,
        exact: true,
    },
    {
        path: '/assemblies/new',
        main: AssemblyNew,
        exact: true,
    },
    {
        path: '/products/new',
        main: ProductCreatePage,
        exact: true,
        requiredPermissions: [Permissions.UpdateProduct],
    },
    {
        path: '/relationships/listing',
        main: RelationshipListing,
        exact: true,
    },
    {
        path: '/relationships/edit/:relationshipId',
        main: RelationshipEdit,
        exact: true,
    },
    {
        path: '/relationships/new',
        main: RelationshipNew,
        exact: true,
    },
    {
        path: '/settings',
        main: AccountSettings,
        exact: true,
        requiredPermissions: [Permissions.AdminMenus],
    },
    {
        path: '/branding',
        main: BrandingSettings,
        exact: true,
    },
    {
        path: '/settings/fees/new',
        main: FeeNew,
        exact: true,
        requiredPermissions: [Permissions.UpdateFee],
    },
    {
        path: '/settings/fees/:feeId/edit',
        main: FeeEdit,
        exact: true,
        requiredPermissions: [Permissions.UpdateFee],
    },
    {
        path: '/settings/fees/listing',
        main: FeeSection,
        exact: true,
        requiredPermissions: [Permissions.UpdateFee],
    },
    {
        path: '/settings/taxes/listing',
        main: TaxSection,
        exact: true,
        requiredPermissions: [Permissions.UpdateTax],
    },
    {
        path: '/settings/newTax',
        main: TaxNew,
        exact: true,
        requiredPermissions: [Permissions.UpdateTax],
    },
    {
        path: '/settings/editTax/:taxId',
        main: TaxEdit,
        exact: true,
    },
    {
        path: '/settings/editCompanyDetails',
        main: CompanyDetailsEdit,
        exact: true,
    },
    {
        path: '/settings/editAccountDetails',
        main: AccountDetailsEditForm,
        exact: true,
    },
    {
        path: '/settings/editProposalOptions',
        main: ProposalOptionsEditForm,
        exact: true,
    },
    {
        path: '/settings/editTemplateSections/:templateSectionId',
        main: ProposalTemplatesEditForm,
        exact: true,
    },
    {
        path: '/settings/editEmailTemplates/:templateKey/listing',
        main: EmailTemplatesEditForm,
        exact: true,
    },
    {
        path: '/settings/editEmailTemplates/:templateKey',
        main: EmailTemplatesEditForm,
        exact: true,
    },
    {
        path: '/settings/editEmailTemplatesById/:templateId',
        main: EmailTemplatesEditForm,
        exact: true,
    },
    {
        path: '/settings/email-templates/:templateKey/listing',
        main: EmailTemplatesListing,
        exact: true,
    },
    {
        path: '/settings/editEmailTemplates/:templateKey/new',
        main: EmailTemplateNew,
        exact: true,
    },
    {
        path: '/settings/sms-templates/:templateKey/listing',
        main: SMSTemplatesListing,
        exact: true,
    },
    {
        path: '/settings/editSMSTemplates/:templateKey',
        main: SMSTemplatesEditForm,
        exact: true,
    },
    {
        path: '/settings/editSMSTemplatesById/:templateId',
        main: SMSTemplatesEditForm,
        exact: true,
    },
    {
        path: '/settings/editSMSTemplates/:templateKey/new',
        main: SMSTemplateNew,
        exact: true,
    },
    {
        path: '/labels/listing',
        main: LabelListing,
        exact: true,
    },
    {
        path: '/labels/edit/:labelId',
        main: LabelEdit,
        exact: true,
    },
    {
        path: '/labels/new',
        main: LabelNew,
        exact: true,
    },
    {
        path: '/calendars/listing',
        main: CalendarListing,
        exact: true,
    },
    {
        path: '/calendars/edit/:calendarId',
        main: CalendarEdit,
        exact: true,
    },
    {
        path: '/calendars/new',
        main: CalendarNew,
        exact: true,
    },
    {
        path: '/custom-field-definitions/listing',
        main: CustomFieldDefinitionListing,
        exact: true,
    },
    {
        path: '/custom-field-definitions/edit/:definitionId',
        main: CustomFieldDefinitionEdit,
        exact: true,
        requiredPermissions: [Permissions.UpdateCustomField],
    },
    {
        path: '/custom-field-definitions/new',
        main: CustomFieldDefinitionNew,
        exact: true,
        requiredPermissions: [Permissions.UpdateCustomField],
    },
    {
        path: '/models/listing',
        main: ModelListing,
        exact: true,
    },
    {
        path: '/models/edit/:modelId',
        main: ModelEdit,
        exact: true,
    },
    {
        path: '/models/new',
        main: ModelNew,
        exact: true,
    },
    {
        path: '/users/listing',
        main: UserListing,
        exact: true,
        requiredPermissions: [Permissions.AccessAllUsers],
        getDefaultRedirectPath: () => { return `/users/edit/${AppContext.getUserLoggedIn().id}` },
    },
    {
        path: '/users/edit/:userId',
        main: UserEdit,
        exact: true,
    },
    {
        path: '/users/notification-settings/edit/:userId',
        main: NotificationSettings,
        exact: true,
    },
    {
        path: '/users/password-settings/edit/:userId',
        main: PasswordSettings,
        exact: true,
    },
    {
        path: '/users/signature-settings/edit/:userId',
        main: SignatureSettings,
        exact: true,
    },
    {
        path: '/users/new',
        main: UserNew,
        exact: true,
        requiredPermissions: [Permissions.AccessAllUsers],
        getDefaultRedirectPath: () => { return `/users/edit/${AppContext.getUserLoggedIn().id}` },
    },
    {
        path: '/locations/listing',
        main: LocationListing,
        exact: true,
        requiredPermissions: [Permissions.AccessAllLocations],
    },
    {
        path: '/locations/:locationId/edit',
        main: LocationEdit,
        exact: true,
        requiredPermissions: [Permissions.AccessAllLocations],
    },
    {
        path: '/locations/template-settings/edit/:locationId',
        main: EditLocationTemplateForm,
        exact: true,
        requiredPermissions: [Permissions.AccessAllLocations],
    },
    {
        path: '/locations/new',
        main: LocationNew,
        exact: true,
        requiredPermissions: [Permissions.AccessAllLocations],
    },
    {
        path: '/payment-terms/listing',
        main: PaymentTermListing,
        exact: true,
        requiredPermissions: [Permissions.UpdatePaymentTerm],
    },
    {
        path: '/payment-terms/:paymentTermId/edit',
        main: PaymentTermEdit,
        exact: true,
        requiredPermissions: [Permissions.UpdatePaymentTerm],
    },
    {
        path: '/payment-terms/new',
        main: PaymentTermNew,
        exact: true,
        requiredPermissions: [Permissions.UpdatePaymentTerm],
    },
    {
        path: '/payment-types/listing',
        main: PaymentTypeListing,
        exact: true,
        requiredPermissions: [Permissions.UpdateCustomPaymentType],
    },
    {
        path: '/payment-types/:paymentTypeId/edit',
        main: PaymentTypeEdit,
        exact: true,
        requiredPermissions: [Permissions.UpdateCustomPaymentType],
    },
    {
        path: '/payment-types/new',
        main: PaymentTypeNew,
        exact: true,
        requiredPermissions: [Permissions.UpdateCustomPaymentType],
    },
    {
        path: '/order-statuses/listing',
        main: StatusPage,
        exact: true,
        feature: AccountFeatures.FeatureOrder,
        requiredPermissions: [Permissions.UpdateCustomOrderStatus],
    },
    {
        path: '/order-statuses/:type/new/:rank',
        main: OrderStatusNew,
        exact: true,
        feature: AccountFeatures.FeatureOrder,
        requiredPermissions: [Permissions.UpdateCustomOrderStatus],
    },
    {
        path: '/order-statuses/:statusId/edit',
        main: OrderStatusEdit,
        exact: true,
        feature: AccountFeatures.FeatureOrder,
        requiredPermissions: [Permissions.UpdateCustomOrderStatus],
    },
    {
        path: '/roles/listing',
        main: RoleListing,
        exact: true,
        requiredPermissions: [Permissions.UpdateRolePermissions],
    },
    {
        path: '/roles/:roleId/edit',
        main: RoleEdit,
        exact: true,
        requiredPermissions: [Permissions.UpdateRolePermissions],
    },
    {
        path: '/roles/new',
        main: RoleNew,
        exact: true,
        requiredPermissions: [Permissions.UpdateRolePermissions],
    },
    {
        path: '/templates/:documentType/listing',
        main: TemplateListing,
        exact: true,
    },
    {
        path: '/templates/:documentId/edit',
        main: TemplateEdit,
        exact: true,
    },
    {
        path: '/templates/:documentType/new',
        main: TemplateNew,
        exact: true,
    },
    {
        path: '/templates/:documentId/sections/preview',
        main: TemplatePreview,
        exact: true,
    },
    {
        path: '/templates/:documentId/sections/:sectionId/edit',
        main: TemplateSectionEdit,
        exact: true,
    },
    {
        path: '/templates/:documentId/sections/new',
        main: TemplateSectionNew,
        exact: true,
    },
    {
        path: '/integrations/listing',
        main: IntegrationListing,
        exact: true,
        requiredPermissions: [Permissions.UpdateAccount],
    },
    {
        path: '/integrations/new/:integrationKey',
        main: IntegrationNew,
        exact: true,
        requiredPermissions: [Permissions.UpdateAccount],
    },
    {
        path: '/integrations/edit/:integrationId',
        main: IntegrationEdit,
        exact: true,
        requiredPermissions: [Permissions.UpdateAccount],
    },
    {
        path: '/my-account',
        main: MyAccount,
        exact: true,
        requiredPermissions: [Permissions.UpdateAccount],
    },
    {
        path: '/embed/ls-retail/create-invoice-modal',
        main: NewInvoiceModalEmbed,
        exact: true,
    },
    {
        path: '/embed/ls-retail/send-invoice-modal',
        main: SendInvoiceEmailModalEmbed,
        exact: true,
    },
    {
        path: '/redirect/zendesk-sell/create-quote-order',
        main: CreateQuoteFromOrderEmbed,
        exact: true,
    },
    {
        path: '/inbox/listing',
        main: MessageListing,
        exact: true,
    },
    {
        path: '/embed/ls-retail/purchase-order',
        main: Orders,
        exact: true,
    },
    {
        path: '/dashboard-v2',
        main: DashboardPage,
        exact: true,
    },
    {
        path: '/vend-redirect-subscription',
        main: VendRedirectSubscription,
        exact: true,
    },
    {
        path: '/welcome/:stepId?',
        main: OnBoardingPage,

    },
    {
        path: '/ecommerce-configuration/quote-cart',
        main: EcommerceConfigurationPage,
        exact: true,
        requiredPermissions: [Permissions.AdminMenus],
    },
    {
        path: '/bottom-line/edit',
        main: BottomPriceEdit,
        exact: true,
    },
    {
        path: '/embed/hubspot/new-document',
        main: NewDocumentComponent,
        exact: true,
    },
    {
        path: '/nylas-migration',
        exact: true,
        main: NylasMigrationComponent,
        centered: true,
    },
]

export default AppRoutes



// WEBPACK FOOTER //
// ./src/privateroutes.jsx